var React = require('react');

function Ghost (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Ghost icon"),React.createElement("path",{"d":"M9.604 19.199H.008V24h9.597v-4.801zm14.39 0h-9.591V24h9.591v-4.801zm.003-9.599H0v4.8h23.997V9.6zM24 0h-4.801v4.801H24V0zm-9.596 0H.008v4.801h14.396V0z","key":1})]);
}

Ghost.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = Ghost;

Ghost.default = Ghost;
